import settings, { isWhiteLabeled } from '../settings'

const { LOCALE_IN_USE } = settings

const extension = isWhiteLabeled() ? 'white-label.json' : 'json'

export const localeMessages = require(`./${LOCALE_IN_USE}.${extension}`)

export function getRawMessage(id, values = {}) {
  if (id in localeMessages) {
    let message = localeMessages[id]
    Object.keys(values).forEach(
      (k) => (message = message.replace(`{${k}}`, values[k]))
    )

    return message
  }

  return id
}
